export const STORE_DEFAULTS = {
  PAGE_CACHE_TTL_MS: 60_000,
  ENTITY_CACHE_TTL_MS: 300_000,
  DEFAULT_PAGE_SIZE: 20,
} as const;

export type StoreDefaults = typeof STORE_DEFAULTS;
